import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core'
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator'
import { PagarePDF, PagareCSV } from 'app/models/pagare.model';
import { PagareService } from 'app/services/pagare.service';
import { take } from 'rxjs';
import { PreviewPaginatorTranslator } from './preview-pagare-paginator-translator';

@Component({
	selector: 'preview-pagare',
	templateUrl: './preview-pagare.component.html',
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: MatPaginatorIntl,
			useClass: PreviewPaginatorTranslator
		}
	]
})
export class PreviewPagareComponent implements OnInit {
	@Input() arrPagares: PagarePDF[];
	@Input() plantilla: string = "PLANTILLA 1";
	isPreview: boolean = true;

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
	length: number = 0;
	pageSize: number = 1;
	pageSizeOptions: number[] = [1];
	pageEvent: PageEvent;

	currentPagare: PagarePDF = null;
	plantillaHtml: string = null;

	constructor(
		private _pagare: PagareService
	) {
	}

	ngOnInit() {
		this.length = this.arrPagares.length;
		this.currentPagare = this.arrPagares[this.paginator.pageIndex];
		this._pagare.obtenerPlantilla(this.plantilla).pipe(take(1)).subscribe({
			next: (info) => {
				this.plantillaHtml = info.plantillaHtml;
			},
			error: (err) => {
				this.plantillaHtml = null;
			},
			complete: () => {
			},
		});
	}

	changePage($event: PageEvent) {
		this.pageEvent = $event;
		this.currentPagare = this.arrPagares[this.pageEvent.pageIndex];
	}

}
